import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import { Button } from '@/shared/components/atoms/Button';
import { Typography } from '@/shared/components/atoms/Typography';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';
import { useFreeTrial } from '@/shared/hooks/useFreeTrial';

import Building from '~/images/shared/building-3.svg';
const DemoCTA: React.FC<{ redirectRouteBeforeExit?: string }> = ({
  redirectRouteBeforeExit,
}) => {
  const { t } = useTranslation();
  const { closeModal } = useModal();

  const { exitDemo, canAccessAssets } = useFreeTrial();

  const { push } = useRouter();

  const handleDemoExit = async () => {
    if (redirectRouteBeforeExit) await push(redirectRouteBeforeExit);
    exitDemo();
    closeModal();
  };

  return (
    <div className='flex max-w-[420px] flex-col items-center gap-32 text-center'>
      <div className='flex h-80 w-80 items-center justify-center rounded-full bg-neutralVariant-96 text-tertiary-20'>
        <Building width='48' height='48' />
      </div>
      <div>
        <Typography weight='bold' variant='h2'>
          {t('in-demo-mode')}
        </Typography>
        <Typography variant='subtitle' className='mt-16 text-surface-10'>
          {t('action-not-saved-switch-to-farm')}
        </Typography>
      </div>
      <div className='w-full'>
        {canAccessAssets && (
          <Button
            variant='text'
            size='full'
            className='mb-8 h-56 !rounded-xl border-xs border-outline-default'
            onClick={handleDemoExit}
          >
            {t('go-to-farm')}
          </Button>
        )}
        <Button
          size='full'
          className='h-56 !rounded-xl'
          onClick={() => closeModal()}
        >
          {t('continue-exploring')}
        </Button>
      </div>
    </div>
  );
};

export default DemoCTA;
